import type { AxiosError } from 'axios';
import type {
  PreAuthenticateInviteRequest,
  PreAuthenticateInviteResponse,
} from '@bvengineering/cas-member-gateway-service-client';
import { useApiMutation } from '@/api/hooks/useMutation';

interface PreAuthenticateInviteMutationVariables {
  magicToken: string;
  preAuthenticateInviteRequest: PreAuthenticateInviteRequest;
}

/**
 * Hook to validate a creator's invite and prepare Cognito for OTP sign-in.
 *
 */
export function usePreAuthenticateInvite() {
  return useApiMutation<
    PreAuthenticateInviteResponse,
    AxiosError,
    PreAuthenticateInviteMutationVariables
  >({
    mutationFn:
      (api) =>
      async ({ magicToken, preAuthenticateInviteRequest }) => {
        const response = await api.auth.creatorsAuthControllerPreAuthenticateInvite(
          magicToken,
          preAuthenticateInviteRequest
        );
        return response.data;
      },
  });
}
